import { styled } from '@linaria/react'
import { FallbackImageSC } from 'atoms/FallbackImage'
import { PosterSC } from 'atoms/ImagePoster'
import { COLOR, FIXED_INDENTS } from 'vars/index'

export const EpgPosterSC = styled.div`
  border-radius: 50%;
  background: var(${COLOR.SURFACE_OPACITY_LIGHT_10});
  padding: var(${FIXED_INDENTS.INDENT_30});
  height: var(--posterSize);
  width: var(--posterSize);
  display: flex;
  ${PosterSC} , ${FallbackImageSC} {
    margin: auto;
    max-height: 100%;
    max-width: 100%;
  }
`
